import { configureStore, createSlice } from "@reduxjs/toolkit";
const initialState = {
    NavIndex: null,
    NavSunIndex: 0,
    NavSonIndex: 0,
    NavSonId: '',
    NavsonOneN: 'ALL'
};
const appSlice = createSlice({
    name: 'app',
    // 初始数据
    initialState,
    // 方法函数 同步
    reducers: {
        setNavIndex(state, action) {
            state.NavIndex = action.payload
        },
        setNavSunIndex(state, action) {
            state.NavSunIndex = action.payload
        },
        setNavSonIndex(state, action) {
            state.NavSonIndex = action.payload
        },
        setNavSonId(state, action) {
            state.NavSonId = action.payload
        },
        setNavsonOneN(state, action) {
            state.NavsonOneN = action.payload
        }
    }
})

export const {
    setNavIndex,
    setNavSunIndex,
    setNavSonIndex,
    setNavSonId,
    setNavsonOneN
} = appSlice.actions

const store = configureStore({
    reducer: {
        app: appSlice.reducer
    }
})
export default store